import React, { useEffect } from 'react';
import config from '../siteConfig';

const AdSenseBanner = ({
  style = { display: 'block' },
  format = 'auto',
  layoutKey = '',
  client,
  slot,
  responsive = 'false',
  layout = '',
  className = ''
}) => {
  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (err) {
      console.log(err);
    }
  }, []);

  // default props
  const props = {
    className: 'adsbygoogle',
    'data-ad-client': config.googleAdSenseClientID
  };

  if (style !== '') {
    props.style = style;
  }
  if (format !== '') {
    props['data-ad-format'] = format;
  }
  if (layoutKey !== '') {
    props['data-ad-layout-key'] = layoutKey;
  }
  if (layout !== '') {
    props['data-ad-layout'] = layout;
  }
  if (client) {
    props['data-ad-client'] = client;
  }
  if (slot) {
    props['data-ad-slot'] = slot;
  }
  if (responsive !== '') {
    props['data-full-width-responsive'] = responsive;
  }
  if (className !== '') {
    props.className = `${props.className} ${className}`;
  }

  return <ins {...props} />;
};

export default AdSenseBanner;

// Usage

// examples from https://github.com/douyacun/react-ssr-adsense

// // ads with no set-up
// <AdSense
//   client='ca-pub-7292810486004926'
//   slot='7806394673'
// />

// // ads with custom format
// <AdSense
//   client='ca-pub-7292810486004926'
//   slot='7806394673'
//   style={{ width: 500, height: 300, float: 'left' }}
//   format=''
// />

// // responsive and native ads
// <AdSense
//   client='ca-pub-7292810486004926'
//   slot='7806394673'
//   style={{ display: 'block' }}
//   layout='in-article'
//   format='fluid'
// />

// // auto full width responsive ads
// <AdSense
//   client='ca-pub-7292810486004926'
//   slot='7806394673'
//   style={{ display: 'block' }}
//   format='auto'
//   responsive='true'
//   layoutKey='-gw-1+2a-9x+5c'
// />
